// extracted by css-extract-rspack-plugin
export default {"full":"NCy4_WGUGa49MQ0x","icon":"pjAXvIgI6kDuEhOr","path":"q2cBMs595QYqhf8J"};